export default function getSvgFonts(svgString) {
  const fontFamilyPattern = /font-family\s*:\s*['"]?([^;"'>]+)/g
  const fonts = new Set()

  let match
  while ((match = fontFamilyPattern.exec(svgString)) !== null) {
    fonts.add(match[1])
  }

  return Array.from(fonts)
}
